import { ArrowClockwise } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

interface ChatRefreshButtonProps {
  onRefresh: () => void
  refreshing?: boolean
}

/**
 * Desktop-only refresh control (D-053). Mobile chat screens render the pull
 * gesture only, through the shared `PullToRefresh` component.
 */
export function ChatRefreshButton({
  onRefresh,
  refreshing = false,
}: ChatRefreshButtonProps) {
  const { t } = useTranslation()

  return (
    <button
      type="button"
      className="grid size-11 place-items-center rounded-full border border-line bg-white text-teal hover:bg-mint disabled:opacity-50"
      onClick={onRefresh}
      disabled={refreshing}
      aria-label={t('chat.refresh')}
      aria-busy={refreshing}
    >
      {refreshing ? (
        <span className="skeleton skeleton--inline" aria-hidden="true" />
      ) : (
        <ArrowClockwise size={18} weight="bold" aria-hidden="true" />
      )}
    </button>
  )
}

export function ChatRefreshStatus({ visible }: { visible: boolean }) {
  const { t } = useTranslation()
  if (!visible) return null
  return (
    <p
      className="mt-3 inline-flex items-center gap-2 text-sm font-semibold text-muted"
      role="status"
      aria-live="polite"
    >
      <span className="skeleton skeleton--inline" aria-hidden="true" />
      {t('chat.refreshing')}
    </p>
  )
}
